// extracted by mini-css-extract-plugin
export default {"IwLink":"IwLink_IwLink"};